const rules = {
  PARTNER_ADMIN: {
    static: [
      '/setting',
      '/login',
      '/sellerAdd',
      '/your-products',
      '/partner-account',
      'product:edit',
      '/centerdetails/:centerId/',
      '/centeredit/:centerId/',
      '/centeradd',
      'product:grouping-create',
      '/your-products/:id',
      '/your-products/:id/variant/:variantId',
      '/your-products/:name/variant/:variantId/inventory-items/:warehouseId',
      '/your-products/:id/order/:variantId',
      'variant:edit',
      '/variant-edit/:id',
      '/create-product',
      '/create-grouping-product',
      '/update-grouping-product',
      '/edit-product/:id',
      '/skus/inventory/:skuId/:name',
      '/your-centers',
      '/integration',
      '/orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      '/orders/variantOrders/:id',
      '/orders/exit-receipts/:id',
      '/orders/exit-receiptsgroup/:id',
      '/orders/helpdesk/:id',
      '/orders/helpical/detail/:id',
      '/alltickets',
      '/alltickets/helpical/detail/:id',
      'orders:history',
      'orderExit:print',
      'post-orders:detail',
      '/partner-warehouses/inventory',
      '/create-grouping-inventory',
      'skus:downloadCSV',
      // '/centersStatistics',
      // '/centersStatistics/details/:id/:nameCenter',
      '/parcels-sender/:id/conflicts',
      'centers:editDetails',
      'centers:createNewCenter',
      'centers:downloadReportCSV',
      'centers:disableCenter',
      'orders:downloadReportCSV',
      'user-name:dontShowInLogs',
      'orders:create',
      'orders-info:more-info',
      'orders:grouping-create',
      'orders:edit',
      'orders:filtersByCenterId',
      '/orders-create',
      '/create-grouping-order',
      '/edit-order/:id',
      `/parcel/helpical-parcel/:id`,
      '/parcel/helpical/detail/:id',
      '/parcels-sender',
      '/parcels-sender/add',
      '/parcels-sender/:id/edit',
      '/parcels-sender/:id/allLogs',
      'parcels-sender:editParcel',
      'parcels-sender:cancelParcel',
      '/parcels/details/:id',
      '/parcels/receipts/:id',
      'parcels-details:print',
      '/print-labels/:id',
      'parcels:downloadReportCSV',
      'parcels:createNewParcel',
      'parcels-detail:downloadCSV',
      '/providers',
      'providers:disable',
      'providers:add',
      '/providerAdd',
      '/sellers',
      'sellers:disable',
      'sellers:add',
      'orders:cancelOrders',
      '/webhooks',
      '/webhooks/create',
      'parcels-detail:downloadInventoryItemCSV',
      '/notification',
      '/partner-warehouses/inventory/:id',
      '/partner-warehouses/inventory/edit/:id/:warehouseId',
      '/orders-menu',
      '/parcels-menu',
      '/orders-returned',
      '/orders-resend/:id',
      '/warehouse-admin-parcels-receipts',
      '/orders/vitrin/:id',
      '/vitrin/categories',
      '/vitrin/products',
      '/vitrin/products/:id',
      '/create-grouping-parcel',
      '/vitrin-orders',
      '/incoming-orders',
      '/vitrin-your-products',
      '/financial-management',
      '/invoice/:id',
      '/pay-process/:id',
      '/redirect',
      '/profile',
      '/packaging',
      '/packaging-preferences',
      '/packaging-consumption-report',
      '/crossdock',
      '/crossdock/:id',
    ],
  },
  CENTER_ADMIN: {
    static: [
      '/',
      '/orders',
      'orders:changeOrderStatus',
      'orders:cancelOrders',
      '/delivery-orders',
      '/orders/:id',
      '/orders/:id/allLogs',
      'orders:changeOrderStatus',
      'products:inventory',
      '/login',
      '/profile',
    ],
  },
  AGENCY_ADMIN: {
    static: [
      '/login',
      '/reports',
      '/reports/current-orders',
      '/reports/center-orders/:centerId',
      'products:inventory',
      '/profile',
    ],
  },
  SELLER_ADMIN: {
    static: [
      '/',
      '/login',
      '/seller-orders',
      '/orders/:id',
      '/seller-products',
      '/seller-parcels',
      '/seller-parcels/add',
      '/seller-parcels/:id/edit',
      '/parcels-sender/:id/allLogs',
      'parcels-sender:editParcel',
      '/parcels-sender/:id/conflicts',
      'parcels-sender:cancelParcel',
      '/parcels/details/:id',
      '/parcels/receipts/:id',
      '/parcels-menu',
      'parcels:downloadReportCSV',
      'parcels:createNewParcel',
      'parcels-detail:downloadCSV',
      'parcels-detail:downloadInventoryItemCSV',
      '/seller-products/:id',
      '/your-products/:id/variant/:variantId',
      '/skus/inventory/:skuId/:name',
      '/orders/variantOrders/:id',
      'user-name:dontShowInLogs',
      'parcels-details:print',
      '/print-labels/:id',
      '/orders/:id/allLogs',
      '/orders-create',
      'orders:create',
      '/create-grouping-order',
      'orders:grouping-create',
      'orders:downloadReportCSV',
      'post-orders:detail',
      'seller_orders:list',
      '/edit-order/:id',
      'products:inventory',
      '/warehouse-admin-parcels-receipts',
      '/orders-returned',
      '/orders-resend/:id',
      '/profile',
    ],
  },
  NONE: {
    static: ['/login'],
  },
};

export default rules;
